import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';

const SpendDetailsPage = lazy(() =>
  import('@/pages/ads/spend-details/spend-details-page').then((m) => ({
    default: m.SpendDetailsPage,
  })),
);

export const Route = createFileRoute('/_app/ads/ad-account-transactions')({
  beforeLoad: requireMenuOrRedirect(
    'menu:ads-admin:ad-account-transactions',
    '/ads/accounts',
  ),
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <SpendDetailsPage />
    </Suspense>
  ),
});
